import script from "./DropdownServices.vue?vue&type=script&setup=true&lang=js"
export * from "./DropdownServices.vue?vue&type=script&setup=true&lang=js"

import "./DropdownServices.vue?vue&type=style&index=0&id=ff7d6a4e&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ff7d6a4e"]])

export default __exports__